"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var MAXIMUM_RECURSION = 1000;
/**
 * Creates accessors and optionally, a proxy, for each iterable
 * property on an object or its prototype.
 */
var getPropertyDescriptorsFromValue = function (store, value, path, depth, isDynamic, isClientSide) {
    var prototype = Object.getPrototypeOf(value);
    // - For staticly typed objects, getters may be present on the prototype.
    // - For dynamic objects (plain objects), reflecting the prototype is not needed and
    //   should be avoided.
    var allKeys = Object.keys(value).concat(isDynamic ? [] : Object.getOwnPropertyNames(prototype));
    return allKeys.reduce(function (localDescriptors, key) {
        var propertyDescriptor = Object.getOwnPropertyDescriptor(value, key) ||
            Object.getOwnPropertyDescriptor(prototype, key);
        if (key === 'constructor')
            return localDescriptors;
        var isAccessorProperty = typeof propertyDescriptor.get === 'function';
        var getter = isAccessorProperty ? propertyDescriptor.get : null;
        // NB: This will result in getters being evaulated once per proxy creation
        var ownValue = value[key];
        var ownPath = __spreadArray(__spreadArray([], path, true), [key], false);
        var isArray = Array.isArray(ownValue);
        var isProxyable = ownValue && typeof ownValue === 'object' && !isArray;
        var isOwnValueDynamic = isProxyable && ownValue.constructor === Object;
        var proxyNode = null;
        if (isProxyable &&
            (!isClientSide || !(ownValue instanceof Node)) &&
            !getter) {
            depth++;
            if (depth > MAXIMUM_RECURSION) {
                throw new Error("Circular reference in store `".concat(store.name, "` at path `").concat(path.join('.'), "`"));
            }
            proxyNode = createObjectProxy(store, ownValue, ownPath, depth);
        }
        localDescriptors.push({
            get: store.readPropertyValue.bind(store, ownPath, false, isOwnValueDynamic, getter),
            set: isAccessorProperty
                ? void 0
                : store.writePropertyValue.bind(store, ownPath),
            proxyNode: proxyNode,
            key: key
        });
        return localDescriptors;
    }, []);
};
/**
 * Creates a "proxy" for any object with a known shape (an instance of a
 * class/constructor), by creating accessors for each iterable and
 * computed property, mapped to their respective "path"s in the overall
 * store's value tree.
 */
var createObjectProxy = function (store, value, path, depth, isClientSide) {
    if (path === void 0) { path = []; }
    if (depth === void 0) { depth = 0; }
    if (isClientSide === void 0) { isClientSide = typeof window !== 'undefined'; }
    var isDynamic = value.constructor === Object;
    return Object.seal(getPropertyDescriptorsFromValue(store, value, path, depth, isDynamic, isClientSide).reduce(function (ownProxyTreeNode, _a) {
        var key = _a.key, get = _a.get, set = _a.set, proxyNode = _a.proxyNode;
        Object.defineProperty(ownProxyTreeNode.proxy, key, {
            enumerable: true,
            get: get,
            set: set
        });
        if (proxyNode) {
            ownProxyTreeNode.children[key] = proxyNode;
        }
        return ownProxyTreeNode;
    }, {
        proxy: Object.create({
            _isProxy: true,
            _isDynamic: isDynamic,
            valueOf: function () { return store.readPropertyValue(path, true); }
        }),
        children: {}
    }));
};
exports.default = createObjectProxy;
//# sourceMappingURL=createObjectProxy.js.map